import { ClerkInstanceContext, useClerkInstanceContext } from '@clerk/shared/react';

export const [IsomorphicClerkContext, useIsomorphicClerkContext] = [ClerkInstanceContext, useClerkInstanceContext];
